module.exports = __webpack_public_path__ + "static/media/smay_bennett.26129ac7.jpg";